import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import { SnackbarService } from '../../core/services/snackbar.service';

@Component({
  selector: 'new-confirm-dialog',
  templateUrl: './new-confirm-dialog.component.html',
  styleUrls: ['./new-confirm-dialog.component.css']
})
export class NewConfirmDialogComponent {
  successText: string = 'Tak';
  failText: string = 'Anuluj';

  constructor(
    public dialogRef: MatDialogRef<NewConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: SnackbarService
  ) {
    if (this.data.successText) {
        this.successText = this.data.successText;
    }
    if (this.data.failText) {
        this.failText = this.data.failText;
    }
  }

  onNoClick(): void {
    this.dialogRef.close({confirm: false});
  }

  confirm(): void {
    this.dialogRef.close({confirm: true});
  }
}
